




































































































import { Component, Vue, Ref, Prop } from "vue-property-decorator";
import InputSmp from "@/components/mpp/SkriningMppInput.vue";
import ListSkriningMpp from "@/components/mpp/ListSkriningMpp.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import SkriningMppModal from "@/components/mpp/SkriningMppModal.vue";
import { confirmRemove } from "@/utility/CommonHelper";
import mppModule from "@/store/modules/MppStore";

@Component({
  components: {
    InputSmp,
    ListSkriningMpp,
    SkriningMppModal
  }
})
export default class SkriningMppPage extends Vue {
  @Ref("refInputSkrining") readonly refInputSkrining!: any;
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;
  @Prop({ type: Boolean, default: false }) isReadonly!: boolean;

  dialog = false;
  saving = false;
  selectedItem: any = null;
  showFullscreen = false;
  category = "skrining";
  loading = false;

  get riwayat() {
    return mppModule.getSkrining;
  }

  get stateUser() {
    return userModule.user;
  }

  async loadData() {
    await mppModule.fetchAllMpp(this.register);
  }

  OpenModal() {
    if (this.refInputSkrining) {
      this.refInputSkrining.resetForm();
    }

    this.selectedItem = {
      id: null,
      unit_id: this.stateUser?.unit_id || null,
      user_id: this.stateUser?.id || null,
      unit: { id: this.stateUser?.unit_id, nama: this.stateUser?.unit },
      user: { id: this.stateUser?.id, nama: this.stateUser?.nama },
      authored_at: new Date(),
      content: {}
    };

    this.dialog = true;
  }

  Close() {
    this.dialog = false;
    setTimeout(() => {
      this.selectedItem = null;
      if (this.refInputSkrining) {
        this.refInputSkrining.resetForm();
      }
    }, 300);
  }

  async Save() {
    if (this.saving || !this.refInputSkrining) return;

    if (this.refInputSkrining && !this.refInputSkrining.validasi()) {
      appModule.sendErrorAlert("Mohon lengkapi Tanggal & Jam Pencatatan.");
      return;
    }

    const input = this.refInputSkrining;

    if (
      !input.isTidakAdaAsuhan &&
      !input.aspects.some((a: any) => a.risikoId?.length > 0)
    ) {
      appModule.sendErrorAlert(
        "Silakan pilih minimal satu kriteria risiko atau centang 'Tidak diperlukan asuhan MPP'"
      );
      return;
    }

    this.saving = true;
    try {
      await mppModule.saveMpp({
        category: this.category,
        data: input.sendData,
        isEdit: !!this.selectedItem?.id
      });

      appModule.NoticeDelay("Data berhasil disimpan");
      this.Close();
    } catch (error) {
      console.error("Error saving skrining:", error);
    } finally {
      this.saving = false;
    }
  }

  Edit(item: any) {
    this.selectedItem = JSON.parse(JSON.stringify(item));
    if (
      this.selectedItem.authored_at &&
      typeof this.selectedItem.authored_at === "string"
    ) {
      this.selectedItem.authored_at = new Date(this.selectedItem.authored_at);
    }
    this.dialog = true;
  }

  async Delete(item: any) {
    const confirmed = await confirmRemove(
      "Hapus Skrining",
      "Apakah Anda yakin ingin menghapus data skrining ini?"
    );

    if (confirmed) {
      try {
        // Panggil API delete
        //await AskepMppSvc.destroy(item.id, this.category, "");
        await mppModule.deleteMpp({
          category: this.category,
          id: item.id
        });

        appModule.NoticeDelay("Data berhasil dihapus");

        // Reload data dari server agar sinkron
        //await this.loadSkriningData();
      } catch (error) {
        console.error("Error deleting skrining askep mpp:", error);
      }
    }
  }
}
